import { toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "w-100" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_avatar = _resolveComponent("v-avatar")!
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_combobox_filled = _resolveComponent("v-combobox-filled")!
  const _component_oss_text_field_filled = _resolveComponent("oss-text-field-filled")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_card_actions = _resolveComponent("v-card-actions")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_v_card_title, { class: "title font-weight-regular justify-space-between d-flex" }, {
      default: _withCtx(() => [
        _createTextVNode(_toDisplayString(_ctx.title) + " ", 1),
        (_ctx.step)
          ? (_openBlock(), _createBlock(_component_v_avatar, {
              key: 0,
              color: "primary lighten-2",
              class: "subheading white--text",
              size: "24",
              textContent: _toDisplayString(_ctx.step)
            }, null, 8, ["textContent"]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }),
    _createVNode(_component_v_card_text, null, {
      default: _withCtx(() => [
        _createVNode(_component_v_row, null, {
          default: _withCtx(() => [
            _createVNode(_component_v_col, null, {
              default: _withCtx(() => [
                _createElementVNode("div", null, _toDisplayString(_ctx.description), 1)
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_v_row, null, {
          default: _withCtx(() => [
            _createVNode(_component_v_col, null, {
              default: _withCtx(() => [
                _createVNode(_component_v_combobox_filled, {
                  items: _ctx.tags,
                  modelValue: _ctx.tag,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.tag) = $event)),
                  label: "Etiquette",
                  "small-chips": "",
                  "no-filter": "",
                  "hide-details": "",
                  "item-disabled": "",
                  "item-value": "name",
                  "item-title": (item) => item.name
                }, null, 8, ["items", "modelValue", "item-title"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        (_ctx.amountSigned <= 0)
          ? (_openBlock(), _createBlock(_component_v_row, { key: 0 }, {
              default: _withCtx(() => [
                _createVNode(_component_v_col, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_oss_text_field_filled, {
                      min: 0,
                      label: "Intérêts",
                      suffix: "€",
                      modelValue: _ctx.loanInterest,
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.loanInterest) = $event))
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        _createVNode(_component_v_row, null, {
          default: _withCtx(() => [
            _createVNode(_component_v_col, null, {
              default: _withCtx(() => [
                _createVNode(_component_oss_text_field_filled, {
                  min: 0,
                  label: "Assurance",
                  suffix: "€",
                  modelValue: _ctx.loanInsurance,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.loanInsurance) = $event))
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    (!_ctx.actions)
      ? (_openBlock(), _createBlock(_component_v_card_actions, { key: 0 }, {
          default: _withCtx(() => [
            _createVNode(_component_v_btn, {
              rounded: "",
              onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.cancel())),
              style: {"margin":"center"},
              size: "small"
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.step ? "Précédent" : "Annuler"), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_v_spacer),
            _createVNode(_component_v_btn, {
              onClick: _ctx.addLoan,
              loading: _ctx.loading,
              disabled: _ctx.disabledAddLoanValidate(),
              size: "small"
            }, {
              default: _withCtx(() => _cache[4] || (_cache[4] = [
                _createTextVNode("Valider")
              ])),
              _: 1
            }, 8, ["onClick", "loading", "disabled"])
          ]),
          _: 1
        }))
      : _createCommentVNode("", true)
  ]))
}